import React from 'react';
import ReactDOM from 'react-dom';
import App from './component/app'


ReactDOM.render(<App />,
  document.getElementById('root'));
